<template>
  <TabTemplate
    :cols="5"
  >
    <template v-slot:chart>
      <StatesLineChart
          @clickPoint="getHoverPoint"
          ref="state"
      ></StatesLineChart>
    </template>
    <template v-slot:content>
      <StatesTable
          :hoverPoint="hoverPoint"
          @setActiveItem="setActiveItem"
      ></StatesTable>
    </template>
  </TabTemplate>
</template>
<script>
import StatesTable from '@/components/state/StatesTable.vue';
import StatesLineChart from '@/components/state/StatesLineChart.vue';
import {mapState} from "vuex";
import TabTemplate from "@/components/common/TabTemplate.vue";

export default {
  name: "StatesTab",
  components: {
    TabTemplate,
    StatesTable,
    StatesLineChart,
  },
  data: () => ({
    hoverPoint: {},
  }),
  computed: {
    ...mapState("statePoints", {
      loading: (state) => state.loading,
    }),
  },
  methods: {
    setActiveItem(event) {
      this.$refs.state.setActiveItem({
        index: event,
      });
    },
    getHoverPoint(point) {
      this.hoverPoint = point;
    },
  },
};
</script>
